import React from 'react'
// import { css } from 'helpers'
import { Trans } from '@lingui/macro'
import Play from '@material-ui/icons/PlayArrow'
import { Button, FlexEnd, FlexOne } from 'webbook-airways'

export default function VideoPlaceholder() {
  return (
    <React.Fragment>
      <FlexOne />
      <FlexEnd>
        <Button variant="outlined" Icon={Play} disabled>
          <Trans>Video coming soon</Trans>
        </Button>
      </FlexEnd>
      {/* <FlexOne />
      <div
        className={css({
          height: 174,
          width: '100%',
          borderRadius: 4,
          backgroundColor: 'white',
          border: '1px solid #ddd',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 25
        })}
      >
        <Typography
          variant="body1"
          style={{
            color: '#ccc',
            fontWeight: 500,
            transform: 'rotate(-8deg)',
            textTransform: 'uppercase'
          }}
        >
          <Trans>Video coming soon</Trans>
        </Typography>
      </div> */}
    </React.Fragment>
  )
}
